import { useEffect, useState } from "react";
import { API_BASE } from "../config/api";
import { buildProgramCards } from "../config/programCatalog";

export function usePrograms() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let ignore = false;

    async function load() {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(`${API_BASE}/programs`);
        const payload = await res.json();

        if (!res.ok) {
          throw new Error(payload.error || "Failed to load programs");
        }

        if (!ignore) {
          setPrograms(buildProgramCards(Array.isArray(payload) ? payload : []));
        }
      } catch (err) {
        if (!ignore) {
          setError(err.message);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, []);

  return { programs, loading, error };
}
